//http://facebook.github.io/fixed-data-table/
import React from 'react';
import BaseReactComponent from '../../Util/BaseReactComponent';
import styles from './SoftwareVersionTable.scss';
import baseComponent from '../../../decorators/baseComponent';
import DataTable from '../../DataTable';

@baseComponent(styles) class SoftwareVersionTable extends BaseReactComponent {

  addNewSoftwareVersion() {
    this.props.onAddNew();
  }

  onEditSoftwareVersion(swVersion) {
    this.props.onEditSoftwareVersion(swVersion);
  }

  render() {
    const versionSort = (version1, version2, sortBy, sortDir) => {
      let a = version1[sortBy];
      let b = version2[sortBy];


      if (isNaN(parseInt(a.charAt(0)))) {
        a = a.replace(a.charAt(0), "999" + a.charCodeAt(0));
      }

      if (isNaN(parseInt(b.charAt(0)))) {
        b = b.replace(b.charAt(0), "999" + b.charCodeAt(0));
      }

      var aSplit = a.split(".");
      var bSplit = b.split(".");


      var length = Math.min(aSplit.length, bSplit.length);
      for (var i = 0; i < length; ++i) {
        if (parseInt(aSplit[i]) < parseInt(bSplit[i])) {
          return sortDir === 'DESC' ? 1 : -1;
        } else if (parseInt(aSplit[i]) > parseInt(bSplit[i])) {
          return sortDir === 'DESC' ? -1 : 1;
        }
      }

      if (aSplit.length < bSplit.length) {
        return sortDir === 'DESC' ? 1 : -1;
      } else if (aSplit.length > bSplit.length) {
        return sortDir === 'DESC' ? -1 : 1;
      }

      return 0;
    }


    return (
      <DataTable rows={this.props.rows} cols={[{ id: 'version', width: 150, sort: versionSort }, 'productName', { id: 'beta2', width: 100 }, { id: 'country2', width: 150 }, 'name', 'edit']} onAddNew={this.addNewSoftwareVersion.bind(this)} onEdit={this.onEditSoftwareVersion.bind(this)} />
    );
  }
}

SoftwareVersionTable.propTypes = {
  rows: React.PropTypes.array,
  onAddNew: React.PropTypes.func,
  onEditSoftwareVersion: React.PropTypes.func
};

export default SoftwareVersionTable;



// WEBPACK FOOTER //
// /src/components/SoftwareVersion/SoftwareVersionTable/SoftwareVersionTable.js